import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const addEditZoneStyle = StyleSheet.create({
    customHeader:
        { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingVertical: 15, paddingHorizontal: 20, borderRadius: 15 },
    nameWrap:
        { paddingHorizontal: 10, backgroundColor: appColors.light, marginVertical: 10, marginHorizontal: 15 },
    contentWrap:
        { backgroundColor: appColors.light, marginHorizontal: 15, paddingHorizontal: 10 },
    wrap2:
        { paddingHorizontal: 10, paddingVertical: 10, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
    arrowCon:
        { flexDirection: 'row', flexWrap: 'wrap' },
    txtWrap:
        { backgroundColor: appColors.lightPrimary, paddingHorizontal: 10, paddingVertical: 10, flexDirection: 'row', marginHorizontal: 5, marginVertical: 10, borderRadius: 15 },
    empCon:
        { flex: 1, justifyContent: 'center', alignItems: 'center' },
    errMsg:
        { marginLeft: 10, color: 'red', fontFamily: appFonts.medium, fontSize: fontSize.errorFontSize },
    infoCon:
        { flexDirection: 'row', paddingTop: 0, alignSelf: 'flex-end', justifyContent: 'space-between' },
    popCon:
        { flex: 1, backgroundColor: appColors.lightBackgroundColor },
    btnWrap:
        { flexDirection: 'row', alignItems: 'center' },
    loaderCon:
        { flex: 1, justifyContent: 'center', alignItems: 'center' },
    listCon:
        { flex: 1, marginHorizontal: 10, justifyContent: 'center' },
    attributesCon:
        { marginVertical: 5, backgroundColor: appColors.light, paddingVertical: 5 },
    attChildWrap:
        { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', },
    btnCon:
        { flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginHorizontal: 15, marginVertical: 10 }

})